import { MainView } from "../../views/signup";

export default function Component(props) {
    return (
        <>
            <MainView />
        </>
    );
}